"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/store/async-value.ts
// module id = 3275
// module chunks = 0